<template>
  <div>
    <template v-if="this.data != null">
      <v-row dense>
        <v-col align="start">
          <b>{{ header }}</b>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col align="center">
          <div class="caption">
            <v-avatar :color="colors[0]" size="8"></v-avatar> {{ $t("powerplant.chart.max") }}: <b>{{ max }} Kč</b> <br />
          </div>

          <AdvancedSparkLine :data="data" :gradient="colors" />

          <div class="caption">
            <v-avatar :color="colors[2]" size="8"></v-avatar> {{ $t("powerplant.chart.min") }}: <b>{{ min }} Kč</b>
          </div>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import AdvancedSparkLine from "../charts/vuetify/AdvancedSparkLine.vue";

export default {
  name: "AnySparkLineChart",
  components: {
    AdvancedSparkLine,
  },
  props: {
    header: {
      type: String,
      require: false,
    },
    data: {
      type: Array,
      require: false,
    },
    max: {
      type: Number,
      require: false,
    },
    min: {
      type: Number,
      require: false,
    },
    colors: {
      type: Array,
      require: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},

  computed: {},
  methods: {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
